module.exports = __webpack_public_path__ + "images/facilicom841ea36f12e1ef4a8669c8a9787eee5c.png";